import React, { useContext } from "react";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// import { MsgContext } from "./D001SearchTop";
import { MsgContext } from "../../App";
import parse from 'html-react-parser';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 * Snackbarの表示
 * @returns 
 */
function CustomizedSnackbar() {
  const { msg, setMsg } = useContext(MsgContext);

  const handleClose = () => {
    setMsg("");
  };

  return (
    // <Stack spacing={2} sx={{ width: '100%' }}>
    //   <Snackbar
    //     open={msg != "" ? true:false}
    //     anchorOrigin={{
    //       vertical: 'top',
    //       horizontal: 'center',
    //     }}
    //     autoHideDuration={6000}
    //     onClose={handleClose}>
    //     <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
    //       {parse(msg)}
    //     </Alert>
    //   </Snackbar>
    // </Stack>
    <>
      <Dialog
        open={msg != "" ? true : false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
        <DialogTitle id="alert-dialog-title">
          {/* {"メッセージタイトル"} */}
          {/* {parse(msg)} */}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"
            color={"darkred"} >
            {parse(msg)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomizedSnackbar;